module.exports = __webpack_public_path__ + "images/category_lp/camera/woman_40_52b0cfc6d060aad314f27de97bf723d7.png";